export default __webpack_public_path__ + "static/media/logo_white.86f74b10.png";